import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ApplicationStatusCard = ({ application }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    const colors = {
      'Under Review': 'bg-warning/10 text-warning border-warning/20',
      'Shortlisted': 'bg-success/10 text-success border-success/20',
      'Rejected': 'bg-error/10 text-error border-error/20',
      'Interview Scheduled': 'bg-primary/10 text-primary border-primary/20'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-warm-sm hover:shadow-warm-md transition-smooth">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
          <Image 
            src={application?.companyLogo} 
            alt={application?.companyLogoAlt}
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-3">
            <div className="flex-1 min-w-0">
              <h4 className="text-base md:text-lg font-heading font-semibold text-card-foreground mb-1 line-clamp-1">
                {application?.position}
              </h4>
              <p className="text-sm text-muted-foreground line-clamp-1">{application?.company}</p>
            </div>
            <span className={`px-3 py-1 rounded-full text-xs font-medium border whitespace-nowrap ${getStatusColor(application?.status)}`}>
              {application?.status}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground line-clamp-1">{application?.location}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground whitespace-nowrap">Applied: {formatDate(application?.appliedDate)}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Briefcase" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground line-clamp-1">{application?.type}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="IndianRupee" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground whitespace-nowrap">{application?.stipend}</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2">
            <Button 
              variant="outline" 
              size="sm"
              iconName="Eye"
              iconPosition="left"
              className="flex-1 sm:flex-initial"
            >
              View Details
            </Button>
            {application?.status === 'Interview Scheduled' && (
              <Button 
                variant="default" 
                size="sm"
                iconName="Calendar"
                iconPosition="left"
                className="flex-1 sm:flex-initial"
              >
                View Schedule
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationStatusCard;